var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 34.5,
    height: 34.5,
    rx: 17.25,
    fill: "#9775FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 34.5,
    height: 34.5,
    rx: 17.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C15.2386 10 13 12.2386 13 15C13 17.7614 15.2386 20 18 20C20.7614 20 23 17.7614 23 15C23 12.2386 20.7614 10 18 10ZM11 15C11 11.134 14.134 8 18 8C21.866 8 25 11.134 25 15C25 16.0644 24.7624 17.0733 24.3374 17.9766L27.464 23.3921C27.6484 23.7114 27.642 24.1064 27.4474 24.4197C27.2529 24.733 26.9016 24.9137 26.5336 24.89L23.601 24.7009L22.2984 27.3362C22.135 27.6668 21.8028 27.8806 21.4342 27.8925C21.0655 27.9044 20.7203 27.7124 20.5359 27.393L18 22.9998L15.4641 27.392C15.2797 27.7114 14.9345 27.9034 14.5659 27.8915C14.1973 27.8797 13.8651 27.6659 13.7017 27.3353L12.3992 24.7011L9.46672 24.891C9.09866 24.9148 8.74737 24.7341 8.55271 24.4208C8.35805 24.1075 8.35165 23.7125 8.53604 23.3931L11.6626 17.9767C11.2376 17.0734 11 16.0645 11 15ZM12.9139 19.8096L11.2025 22.7744L12.9355 22.6621C13.3384 22.636 13.7175 22.8549 13.8965 23.2168L14.6663 24.7738L16.377 21.8109C15.0302 21.4911 13.8341 20.7823 12.9139 19.8096ZM19.6229 21.8109C20.9698 21.4912 22.166 20.7822 23.0862 19.8095L24.7977 22.7739L23.0643 22.6621C22.6614 22.6361 22.2824 22.855 22.1035 23.2169L21.3336 24.7745L19.6229 21.8109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.a531425d491390bfa332a4a33453af77.svg";
export { ForwardRef as ReactComponent };